export default {
    UserState: 'next_source_state_v',
    SiteId: 'site_id',
};
